import axios from "axios";
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from "../../../Notifications/ToastifyActions";

function cleanParams(params) {
  const out = {};
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== "") out[k] = v;
  });
  return out;
}

function FetchStoreOrdersService(token, profileId, params) {
  return axios
    .get(
      `${CURRENT_API_URL}/sellerPartner/api/store-orders/${profileId}/orders/`,
      {
        headers: { Authorization: token },
        params: cleanParams(params),
      }
    )
    .then((res) => res.data)
    .catch((error) => {
      const detail =
        (error.response && error.response.data && error.response.data.detail) ||
        "An error occurred while fetching orders.";
      notify.NotifyError(detail);
      throw new Error(detail);
    });
}

export default FetchStoreOrdersService;
